import React, { useCallback } from 'react';

import { useNavigate } from 'react-router-dom';

import Button from '@amzn/meridian/button';
import Row from '@amzn/meridian/row';
import { type AssociateProfilePlacement } from 'src/services/associateProfile/types';
import { setJmrFlowType } from 'src/store/newJmrPageSlice/newJmrPageSlice';
import { useAppDispatch } from 'src/store/store';
import { JmrFlowTypes } from 'src/utils/jmrUtils';

interface TransferActionsProps {
  placement: AssociateProfilePlacement;
}

const TransferActions = ({ placement }: TransferActionsProps) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const startAcceptTransferJmrFlow = useCallback(() => {
    dispatch(setJmrFlowType(JmrFlowTypes.CompleteTransfer));
    navigate(`/newJMR/${placement.accommodationId}/update/${JmrFlowTypes.CompleteTransfer}`);
  }, [dispatch, navigate, placement.accommodationId]);

  return (
    <Row spacing="300" alignmentHorizontal="end">
      <Button type="primary" onClick={startAcceptTransferJmrFlow}>
        Accept
      </Button>
    </Row>
  );
};

export default TransferActions;
